import {GovFormControl, GovFormGroup, GovFormInput, GovFormLabel, GovFormMessage} from "@gov-design-system-ce/react";

export interface TextFieldProps {
    value?: string;
    readOnly?: boolean;
    prefix?: string;
    suffix?: string;
    message?: string;
    label?: string;
    onChange?: (value: string) => void;
}

export default function TextField(props: TextFieldProps) {
    const {value, readOnly, message, label, onChange} = props;

    return (
        <GovFormControl>
            <div>
                {label && <GovFormLabel slot="top" size="l">
                    {label}
                </GovFormLabel>}
                <GovFormGroup>
                    <GovFormInput size="m" variant="secondary" input-type="text"
                                  value={value}
                                  disabled={readOnly}
                                  onGov-input={(e) => onChange && onChange(e.detail.value)}
                    />
                </GovFormGroup>

                {message && <GovFormMessage slot={"bottom"} variant={"secondary"}>
                    {message}
                </GovFormMessage>}
            </div>

        </GovFormControl>
    );

}